// Shared Result type and ApplyError shape. The reducer never throws for game-rule
// failures (e.g. not enough cash) — those return { ok: false, error }.
// Throws are reserved for programmer errors (bad config, unreachable case).

import type { GameState, OutboundEvent } from '../state/types.js';

export type Result<T, E> = { ok: true; value: T } | { ok: false; error: E };

export type ApplyError = {
  code: string;
  message: string;
  meta?: Record<string, unknown>;
};

export type ApplyOutcome = {
  state: GameState;
  outbound: OutboundEvent[];
};

export type ApplyResult = Result<ApplyOutcome, ApplyError>;

export const ok = (state: GameState, outbound: OutboundEvent[] = []): ApplyResult => ({
  ok: true,
  value: { state, outbound },
});

export const fail = (code: string, message: string, meta?: Record<string, unknown>): ApplyResult =>
  ({ ok: false, error: { code, message, meta } });
